import Hooks from 'classes/Hooks';

export const global_hooks = new Hooks([]);